import {CommonModule} from '@angular/common';
import {Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {TranslateModule} from '@ngx-translate/core';
import {PaymentExpiredComponent} from '../../components/payment-expired/payment-expired.component';
import {FooterComponent} from '../../layouts/footer/footer.component';

@UntilDestroy()
@Component({
  selector: 'app-error-timeout',
  standalone: true,
  template: `
    <app-payment-expired
      [heading]="'ERRORS.PAYWALL_ERRORS.TimeoutTitle' | translate"
      [description]="'ERRORS.PAYWALL_ERRORS.TimeoutDescription' | translate"
    >
    </app-payment-expired>
    <app-footer></app-footer>
  `,
  styles: [
    `
      :host {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding-top: 40px;
      }
    `,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PaymentExpiredComponent,
    FooterComponent,
  ],
})
export class ErrorTimeoutComponent implements OnInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {}
  ngAfterViewInit() {
    // the below code looks for the parent div to override its styles to match the payment link expired page styles.
    // this is required as the default container always has a fixed background color
    let parent = this.el.nativeElement.parentElement;

    // Traverse all the way up to find a div with the class "container-fluid"
    while (parent) {
      // check if the parent is a div and has the class "container-fluid"
      // if so, set the background color to match the payment link expired page styles
      if (
        parent.tagName === 'DIV' &&
        parent.classList.contains('container-fluid')
      ) {
        this.renderer.setStyle(
          parent,
          'background',
          'var(--Primary-Gray-10, #F7F7F7)'
        );
        // break the loop once we find the target div and set its styles
        break;
      }
      // move to one level up in the DOM tree
      parent = parent.parentElement;
    }
  }
}
